module.exports = __webpack_public_path__ + "img/c6.bdfeaac3.png";